import { ServiceFetch } from '../service-fetch'

export default class TimeWorkListModel extends ServiceFetch {
    getTimeWorkListBy = (data) => this.authFetch({
        url: 'time-work-list/getTimeWorkListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}